import { render } from "./SuccessNotification.vue?vue&type=template&id=6317359b&scoped=true"
import script from "./SuccessNotification.vue?vue&type=script&lang=js"
export * from "./SuccessNotification.vue?vue&type=script&lang=js"

import "./SuccessNotification.vue?vue&type=style&index=0&id=6317359b&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6317359b"]])

export default __exports__